interface SectionTitleProps {
  title: string;
}

export const SectionTitle = ({ title }: SectionTitleProps) => (
  <div className="text-sm font-semibold text-gray-900 mb-3">{title}</div>
);
